module.exports = __webpack_public_path__ + "img/card_barber_shop_200.73417e17.jpg";